import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validatedUser } from "../utils/validateUser";

interface UseDevAuthReturn {
  isDevMode: boolean;
  showDevModal: boolean;
  isLoading: boolean;
  botIdValue: string;
  handleBotIdChange: (value: string) => void;
  handleBotIdSubmit: (botIdValue: string) => Promise<void>;
  handleCloseModal: () => void;
}

export const useDevAuth = (): UseDevAuthReturn => {
  const [searchParams, setSearchParams] = useSearchParams();
  const history = useNavigate();
  const [showDevModal, setShowDevModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [botIdValue, setBotIdValue] = useState(
    () => searchParams.get("bot_id") || "",
  );

  const isDevMode = process.env.REACT_APP_IS_PROD === "false";

  useEffect(() => {
    if (!isDevMode) {
      return;
    }

    const botId = searchParams.get("bot_id");

    if (!botId) {
      setShowDevModal(true);
      return;
    } else {
      setBotIdValue(botId);
    }
  }, [isDevMode, searchParams]);

  const handleBotIdSubmit = async (botIdValue: string) => {
    if (!botIdValue || !botIdValue.trim()) {
      alert("Por favor, insira um bot_id válido");
      return;
    }

    const cleanBotId = botIdValue.trim();

    setIsLoading(true);

    try {
      // Em DEV mode, a validação já retorna sucesso
      const logged = await validatedUser(cleanBotId, "dev-token", null);

      if (logged) {
        // Atualiza URL com bot_id
        const newParams = new URLSearchParams(searchParams);
        newParams.set("bot_id", cleanBotId);
        setSearchParams(newParams);
        setShowDevModal(false);
      } else {
        alert("Falha na validação. Verifique o bot_id.");
      }
    } catch (error) {
      alert("Erro ao validar. Verifique o console.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBotIdChange = (value: string) => {
    setBotIdValue(value);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("bot_id", value);
    setSearchParams(newParams);
  };

  const handleCloseModal = () => {
    setShowDevModal(false);
  };

  return {
    isDevMode,
    showDevModal,
    isLoading,
    botIdValue,
    handleBotIdChange,
    handleBotIdSubmit,
    handleCloseModal,
  };
};
